<template>
  <AppContainer justify-center>
    <div class="space-y-4 text-center">
      <EIcon :icon class="text-red-500" size="2xl" />
      <p>{{ message }}</p>
    </div>
    <template #bottom>
      <slot name="actions" />
    </template>
  </AppContainer>
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import { EIcon } from '@expansivefm/eds'

defineProps({
  icon: {
    type: String,
    default: 'ban',
  },
  message: {
    type: String,
    required: true,
  },
})
</script>
